export default "__VITE_ASSET__BDqij9Cf__"